var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"shop-status-wrapper",class:_vm.size},[_c('div',{staticClass:"center-box"},[(_vm.size !== 'small' || _vm.timeDesc)?_c('p',{staticClass:"open-time-text",domProps:{"textContent":_vm._s(_vm.timeDesc)}}):_vm._e(),_c('div',{staticClass:"shop-status-desc",domProps:{"textContent":_vm._s(_vm.statusDesc)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }